import { LOCALE_ID, NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { AgePipe } from "./age.pipe";

import { BEDatePipe } from "./bedate.pipe";
import { UniDatePipe } from "./unidate.pipe ";
import { CustomDatePipe } from "./custom-date.pipe";
import { DurationTimePipe } from "./duration-time.pipe";
import { DurationVideoPipe } from "./duration-video.pipe";
import { JoinArrayPipe } from "./join-array.pipe";
import { TimeIntervalPipe } from "./time-interval.pipe";
import { SetZeroBlankPipe } from "./set-zero-blank.pipe";

@NgModule({
  imports: [
    CommonModule,
    AgePipe,
    BEDatePipe,
    UniDatePipe,
    CustomDatePipe,
    DurationTimePipe,
    DurationVideoPipe,
    TimeIntervalPipe,
    JoinArrayPipe,
    SetZeroBlankPipe,
  ],
  exports: [
    BEDatePipe,
    AgePipe,
    UniDatePipe,
    CustomDatePipe,
    DurationTimePipe,
    DurationVideoPipe,
    TimeIntervalPipe,
    JoinArrayPipe,
    SetZeroBlankPipe,
  ],
  providers: [DatePipe],
})
export class PipesModule {}
